window.DtfDesignSummary = (function () {
  function init(productFormId, templateWithPlaceholder) {
    var params = new URLSearchParams(window.location.search);
    var title = params.get('design_title');
    if (!title) return;

    var input = document.getElementById('DtfDesignInput-' + productFormId);
    var summary = document.getElementById('DtfDesignSummary-' + productFormId);
    if (!input || !summary) return;

    input.value = title;
    var text = summary.querySelector('.dtf-design-summary__text');
    if (text) {
      text.textContent = templateWithPlaceholder.replace('__TITLE__', title);
    }
    summary.hidden = false;
  }

  return { init: init };
})();
